import { createApp } from 'vue';
import CompletedHikes from "./CompletedHikes.vue";
import { i18n } from '../../i18n';

function mountCompletedHikesApp(elementId: string) {
  const el = document.getElementById(elementId)
  if (!el) return

  // The public-profile mount passes { context: 'public', firebaseUserId } via a
  // data-app-config attribute; the logged-in user's own page passes nothing and
  // defaults to the 'current' context.
  let config: { context?: string; firebaseUserId?: string } = {}
  try {
    config = JSON.parse(el.dataset.appConfig || '{}')
  } catch (_) {
    config = {}
  }

  const app = createApp(CompletedHikes, {
    context: config.context || 'current',
    firebaseUserId: config.firebaseUserId || null
  })
  app.use(i18n);
  app.mount(`#${elementId}`)
}

if (document.getElementById('completed-hikes-app')) {
  mountCompletedHikesApp('completed-hikes-app')
}
